import React, { useState } from "react";
import { Chip } from "primereact/chip";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { axiosInstance } from "../axios/axiosConfig";
const Chips = {
  Latest: "Latest",
  Top: "Top",
  Prominent: "Prominent",
  Closed: "Closed",
};

const defaultChipsActive = {
  Latest: false,
  Top: false,
  Prominent: false,
  Closed: false,
};

export default function CourseDiscussion({ props }) {
  const [isActive, setIsActive] = useState(defaultChipsActive);
  const [data, setData] = useState([]);

  React.useEffect(() => {
    setIsActive((draft) => ({
      ...draft,
      Latest: true,
    }));
  }, []);

  React.useEffect(() => {
    async function fetchData() {
      try {
        const response = await axiosInstance.get(
          "/trainer/courses/comments?courseCode=1"
        );
        setData(response.data);
      } catch (error) {
        //console.error(error);
      }
    }
    fetchData();
  }, []);

  const handleChipActive = (chipType) => {
    const newState = { ...defaultChipsActive };
    newState[chipType] = true;
    setIsActive(newState);
  };

  function timeDifference(current, previous) {
    var msPerMinute = 60 * 1000;
    var msPerHour = msPerMinute * 60;
    var msPerDay = msPerHour * 24;
    var msPerWeek = msPerDay * 7;
    var msPerMonth = msPerDay * 30;
    var msPerYear = msPerDay * 365;

    var elapsed = current - previous;

    if (elapsed < msPerMinute) {
      return Math.round(elapsed / 1000) + " seconds ago";
    } else if (elapsed < msPerHour) {
      return Math.round(elapsed / msPerMinute) + " minutes ago";
    } else if (elapsed < msPerDay) {
      return Math.round(elapsed / msPerHour) + " hours ago";
    } else if (elapsed < msPerWeek) {
      return Math.round(elapsed / msPerDay) + " days ago";
    } else if (elapsed < msPerMonth) {
      return Math.round(elapsed / msPerWeek) + " weeks ago";
    } else if (elapsed < msPerYear) {
      return Math.round(elapsed / msPerMonth) + " months ago";
    } else {
      return Math.round(elapsed / msPerYear) + " years ago";
    }
  }

  const svgHotIcon = (
    <svg
      className="mr-2"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 12 13"
      fill="none"
    >
      <g clip-path="url(#clip0_5354_97367)">
        <path
          d="M6.25 12.5C5.38982 12.5 4.59435 12.2832 3.86358 11.8496C3.13281 11.416 2.55619 10.8242 2.13371 10.0742C1.71124 9.32422 1.5 8.50781 1.5 7.625C1.5 7.28125 1.54948 6.9707 1.64844 6.69336C1.7474 6.41602 1.86919 6.16797 2.01382 5.94922C2.15845 5.73047 2.30308 5.49219 2.44772 5.23438C2.59235 4.97656 2.71414 4.63672 2.8131 4.21484C2.91206 3.79297 2.96154 3.30469 2.96154 2.75C2.96154 2.82812 3.0015 2.9043 3.08143 2.97852C3.16136 3.05273 3.25651 3.12695 3.36689 3.20117C3.47726 3.27539 3.59906 3.40625 3.73227 3.59375C3.86548 3.78125 3.97396 4 4.05769 4.25C4.17949 4.63281 4.3774 4.97852 4.65144 5.28711C4.92548 5.5957 5.21474 5.75 5.51923 5.75C5.91506 5.75 6.2519 5.51953 6.52975 5.05859C6.80759 4.59766 7.01312 3.97656 7.14633 3.19531C7.27955 2.41406 7.34615 1.51562 7.34615 0.5C7.46034 0.84375 7.63542 1.20312 7.87139 1.57812C8.10737 1.95312 8.35667 2.29297 8.61929 2.59766C8.88191 2.90234 9.15785 3.25 9.44712 3.64062C9.73638 4.03125 9.99329 4.41211 10.2178 4.7832C10.4424 5.1543 10.6289 5.58789 10.7773 6.08398C10.9258 6.58008 11 7.09375 11 7.625C11 8.50781 10.7888 9.32422 10.3663 10.0742C9.94381 10.8242 9.36719 11.416 8.63642 11.8496C7.90565 12.2832 7.11018 12.5 6.25 12.5ZM7.71154 5C7.32332 6.0625 6.95793 6.8125 6.61538 7.25C6.47075 7.4375 6.28996 7.60547 6.07302 7.75391C5.85607 7.90234 5.65815 8.02148 5.47927 8.11133C5.30038 8.20117 5.1272 8.30273 4.95974 8.41602C4.79227 8.5293 4.66096 8.67383 4.56581 8.84961C4.47065 9.02539 4.42308 9.24219 4.42308 9.5C4.42308 9.97656 4.60387 10.3457 4.96544 10.6074C5.32702 10.8691 5.75521 11 6.25 11C6.98077 11 7.58974 10.8027 8.07692 10.4082C8.5641 10.0137 8.80769 9.47656 8.80769 8.79688C8.80769 8.27344 8.76583 7.82227 8.68209 7.44336C8.59836 7.06445 8.50321 6.7832 8.39663 6.59961C8.29006 6.41602 8.16827 6.18164 8.03125 5.89648C7.89423 5.61133 7.78766 5.3125 7.71154 5Z"
          fill="#808080"
        />
      </g>
      <defs>
        <clipPath id="clip0_5354_97367">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );

  return (
    <div className="flex flex-column course-discussion-container">
      <h4 className="text-2xl m-0 ml-3 mt-3">Discussion</h4>
      <div className="discussion-comments-container border-round-md m-3">
        <div className="discussion-comments-header flex flex-wrap m-3 gap-2">
          <Chip
            label="Latest"
            icon="pi pi-clock"
            onClick={() => handleChipActive(Chips.Latest)}
            className={isActive.Latest ? "chip-active" : ""}
          />
          <Chip
            label="Top"
            icon="pi pi-arrow-up-right"
            onClick={() => handleChipActive(Chips.Top)}
            className={isActive.Top ? "chip-active" : ""}
          />
          <Chip
            label="Prominent"
            icon={svgHotIcon}
            onClick={() => handleChipActive(Chips.Prominent)}
            className={isActive.Prominent ? "chip-active" : ""}
          />
          <Chip
            label="Closed"
            icon="pi pi-check-circle"
            onClick={() => handleChipActive(Chips.Closed)}
            className={isActive.Closed ? "chip-active" : ""}
          />
        </div>
        <div className="discussion-comments-content">
          {data &&
            data.map((discussion) => (
              <div className="discussion-comments-item m-3 p-3 flex flex-column gap-3 border-round-md border-solitude-color border-1">
                <div className="comment-header flex align-items-center">
                  <img
                    src="https://placehold.co/40x40"
                    class="h-2rem w-2rem border-circle mr-3"
                  />
                  <div className="comment-title">
                    <p className="mb-0 text-sm">{discussion.userFullName}</p>
                    <p className="text-xs">
                      {timeDifference(
                        new Date(),
                        new Date(discussion.createdTimeStamp * 1000)
                      )}
                    </p>
                  </div>
                  <div className="comment-options">
                    <Button
                      icon="pi pi-ellipsis-v"
                      text
                      className="text-sm default-text"
                    />
                  </div>
                </div>
                <div className="comment-content">
                  <p className="text-sm">{discussion.discussionComment}</p>
                  <div className="flex p justify-content-between align-items-center">
                    <p className="text-sm secondary-text">
                      {discussion.replyComment}
                    </p>
                    <Button label="View more" text className="text-sm" />
                  </div>
                </div>
                <div className="comment-footer flex flex-wrap gap-3 align-items-center justify-content-between">
                  <div>
                    {discussion.hashTags &&
                      discussion.hashTags.map((tag) => (
                        <a href="#" className="text-xs mr-2">{`#${tag}`}</a>
                      ))}
                  </div>
                  <div className="flex gap-3">
                    <div className="flex">
                      <i className="pi pi-eye text-xs mr-1" />
                      <p className="m-0 text-xs">{discussion.totalViews}</p>
                    </div>
                    <div className="flex">
                      <i className="pi pi-comment text-xs mr-1" />
                      <p className="m-0 text-xs">{discussion.totalComments}</p>
                    </div>
                    <div className="flex">
                      <i className="pi pi-arrow-up text-xs mr-1" />
                      <p className="m-0 text-xs">{discussion.totalUps}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          <div className="discussion-add-comment m-3 flex gap-3">
            <InputText
              type="text"
              className="w-full"
              placeholder="Write comment."
            />
            <Button label="Send" severity="help" />
          </div>
        </div>
      </div>
    </div>
  );
}
